import React, { useState } from 'react';
import I18n from '@/modules/i18n';
import styles from '@/components/shared/Correlations/Correlations.module.scss';
import * as Routes from '@/modules/routes';
import { UnitType, TagType } from '@/components/shared/Correlations/types';
import useUnitTagValues from '@/components/shared/Correlations/hooks/useUnitTagValues';
import cn from "@/utils/cn";
import Text from '@/components/ui/Text';

type UnitTagContentType = {
  programId: number,
  tag: TagType,
  unit: UnitType,
  headerLabel: string,
};

const UnitTagContent = ({ programId, tag, unit, headerLabel }: UnitTagContentType) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { data: tagValues, isLoading } = useUnitTagValues({
    isEnabled: isExpanded, programId, tagId: tag.id, unitId: unit.id,
  });

  return (
    <div key={headerLabel} className={styles.lesson}>
      <Text asChild size="sm" weight="bold">
        <button
          className={cn(
            `tw-bg-transparent tw-border-none tw-cursor-pointer tw-outline-none
                   hover:tw-bg-white hover:tw-bg-opacity-25 focus:tw-bg-white focus:tw-bg-opacity-25
                   focus:tw-outline-none`,
            styles.tagButton,
          )}
          type="button"
          onClick={() => setIsExpanded(prevState => !prevState)}
        >
          <i className={`fa ${isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'} tw-mr-[8px]`} />
          {headerLabel}
          {isExpanded && isLoading && <i className="fa fa-spinner fa-spin tw-ml-[8px]" />}
        </button>
      </Text>
      {isExpanded && (
        <div className="tw-ml-[20px] tw-mt-[8px]">
          {isLoading && (
            <div>Loading tag values...</div>
          )}

          {!isLoading && !tagValues && (
            <div>No content available for this tag</div>
          )}

          {!isLoading && tagValues && (
            <ul className="tw-list-disc">
              {tagValues.notebooks.map(notebook => (
                <li key={notebook.id}>
                  <Text asChild size="sm">
                    <a
                      href={Routes.stream_shared_program_investigations_path(
                        programId,
                        { anchor: `section-${notebook.id}`,
                          expanded: notebook.id,
                          unit_id: unit.id,
                          unit_projects: true,
                        },
                      )}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {`${I18n.t('unit_projects')} / ${notebook.label}`}
                    </a>
                  </Text>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default UnitTagContent;
